<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { emptyValuation, color as contributorColor} from "../../Contributor.svelte";
    import ConfigureContributorDialog from "../dialogs/ConfigureContributorDialog.svelte";
    import InviteContributorsDialog2 from "../dialogs/InviteContributorsDialog2.svelte";

    import { createEventDispatcher } from 'svelte';

    import Card, {Content, PrimaryAction, Media, MediaContent, Actions, ActionButtons, ActionIcons} from '@smui/card';
    import {Label} from '@smui/button';
    import IconButton from '@smui/icon-button';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import {Anchor} from '@smui/menu-surface';
    import List, {Item, Separator, Text, PrimaryText, SecondaryText, Graphic} from '@smui/list';
    import { userPlus } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';

    import Button from "../form/Button.svelte";
    import NewEntryDialog from "../dialogs/NewEntryDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import Name from "../Name.svelte";

    const dispatch = createEventDispatcher();

    export let project;
    export let projectId;
    export let myUserId;

    let showContributorConfigDialog = false;
    let showInviteDialog = false;

    $: showDialog = showContributorConfigDialog || showInviteDialog;

    function close() {
        showContributorConfigDialog = showInviteDialog = false;
    }

</script>

<Card class="contributor-card placeholder" style="width: 360px; overflow: visible; margin: 25px; margin-top: 50px; position: relative">
    <ProfilePicture style="width: 225px; height: 225px; margin: auto; position: relative; top: -50px; margin-top: 0;" size="5" placeholder={true}/>
    <Content class="mdc-typography--body2" style="text-align: center">
        <h2 class="contributor-name">
            <Button on:click={() => showInviteDialog = true}><Icon scale={1} data={userPlus} style="margin-right: 4px;"/>Invite participant...</Button>
        </h2>
    </Content>
    <Actions>

    </Actions>
</Card>

<Overlay show={showDialog} closable={true} background="darken" on:close={close}>
    <ConfigureContributorDialog
            {projectId}
            isSelf={false}
            on:new={close}
            show={showContributorConfigDialog}
    />

    <InviteContributorsDialog2
            {project}
            on:invited
            on:close={close}
            on:invite
            show={showInviteDialog}
            />
</Overlay>

<style>

</style>